
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.076 2.857a1.99 1.99 0 113.981-.019 1.99 1.99 0 01-3.98.02zm-7.533 0a1.981 1.981 0 113.962 0 1.981 1.981 0 01-3.962 0zM0 2.857a1.99 1.99 0 111.981 1.981A1.981 1.981 0 010 2.858z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    